



















import Vue from 'vue'
import bus from './model/bus'
import Bar from './components/Bar.vue'
import Home from './components/Home.vue'
import ArkList from './components/ArkList.vue'
import CreatureList from './components/CreatureList.vue'
import ItemSet from './components/ItemSet.vue'
import Loot from './components/Loot.vue'
import LootList from './components/LootList.vue'
import ResourceList from './components/ResourceList.vue'

export default Vue.extend({
    name: 'app',
    components: {
        Bar,
        Home,
        ArkList,
        CreatureList,
        ItemSet,
        Loot,
        LootList,
        ResourceList,
    },
    data() {
        return {
            bus,
        }
    },
})
